import React, { useEffect, useRef, useState } from "react";

// Textarea where typing "@" suggests staff; picking one inserts "@Name" and adds them to `picked`.
export default function MentionInput({ client, value, onChange, picked, setPicked, rows = 3, testid = "task-text-input",
  placeholder = "Describe the task… type @ to assign staff (e.g. @Anu please call the customer)" }) {
  const [people, setPeople] = useState([]);
  const [query, setQuery] = useState(null);
  const [hi, setHi] = useState(0);
  const ref = useRef(null);
  useEffect(() => { client.get("/crm-tasks/people").then(r => setPeople(r.data)).catch(() => {}); }, [client]);

  const onText = (e) => {
    const v = e.target.value;
    onChange(v);
    const m = v.slice(0, e.target.selectionStart).match(/@([\w .]{0,30})$/);
    setQuery(m ? m[1] : null); setHi(0);
    setPicked(picked.filter(p => v.includes(`@${p.name}`)));
  };
  const matches = query === null ? [] : people.filter(p => (p.name || "").toLowerCase().includes(query.trim().toLowerCase())
    && !picked.some(x => x.id === p.id)).slice(0, 6);
  const choose = (p) => {
    const el = ref.current, pos = el.selectionStart;
    const before = value.slice(0, pos).replace(/@([\w .]{0,30})$/, `@${p.name} `);
    onChange(before + value.slice(pos));
    setPicked([...picked, p]); setQuery(null);
    setTimeout(() => { el.focus(); el.selectionStart = el.selectionEnd = before.length; }, 0);
  };
  const onKey = (e) => {
    if (!matches.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi(h => (h + 1) % matches.length); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi(h => (h - 1 + matches.length) % matches.length); }
    else if (e.key === "Enter" || e.key === "Tab") { e.preventDefault(); choose(matches[hi]); }
    else if (e.key === "Escape") setQuery(null);
  };
  return (
    <div className="relative">
      <textarea ref={ref} value={value} onChange={onText} onKeyDown={onKey} rows={rows} data-testid={testid}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-[#E5E2D9] rounded-lg text-sm focus:border-[#DC2626] outline-none resize-none" />
      {matches.length > 0 && (
        <div className="absolute z-30 left-0 right-0 top-full mt-1 bg-white border border-[#E5E2D9] rounded-lg shadow-lg overflow-hidden"
             data-testid={testid === "task-text-input" ? "task-mention-list" : `${testid}-mentions`}>
          {matches.map((p, i) => (
            <button type="button" key={p.id} onMouseDown={e => { e.preventDefault(); choose(p); }}
              data-testid={testid === "task-text-input" ? `task-mention-${p.id}` : `${testid}-mention-${p.id}`}
              className={`w-full text-left px-3 py-2 text-sm flex items-center justify-between ${i === hi ? "bg-[#FEF2F2]" : "hover:bg-[#FAFAF7]"}`}>
              <span>{p.name}</span><span className="text-[10px] uppercase tracking-wider text-[#8A8780]">{p.role?.replace("_", " ")}</span>
            </button>))}
        </div>)}
    </div>
  );
}
